import React, { useState, useEffect } from 'react';
import './Login.css';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import LoaderScreen from '../../components/LoaderScreen/LoaderScreen';
import { useCookies } from 'react-cookie';
import { t } from '../../functions/genericFunctions';

function Login() {
  const navigate = useNavigate();

  const [loginIdInput, setLoginIdInput] = useState("");
  const [passwordInput, setPasswordInput] = useState("");
  const [apiResponseText, setApiResponseText] = useState("");
  const [showLoaderScreenFlag, setShowLoaderScreenFlag] = useState(false);

  const [cookie, setCookie] = useCookies();

  function submitForm() {
    const api_endpoint = process.env.REACT_APP_API_BASE_URL + "/user/login";

    setShowLoaderScreenFlag(true);

    const body = {
      email: loginIdInput,
      password: passwordInput
    };

    axios
      .post(api_endpoint, body)
      .then((response) => {
        setShowLoaderScreenFlag(false);

        setApiResponseText(t("login_success"));

        setCookie("token", response.data.data.accessToken, { path: "/" });
        setCookie("userData", response.data.data.userData, { path: "/" });

        setTimeout(() => {
          navigate("/home");
        }, 500);
      })
      .catch((error) => {
        console.log(error?.response?.data);
        setShowLoaderScreenFlag(false);
        setApiResponseText(t("login_failed"));
      });
  }

  useEffect(() => {
    if (cookie['token']) {
      navigate("/home");
    }
  }, []);

  return (
    <>
      <div id="login-page">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="loginFormContainer">
                <div className="loginLogoContainer">
                  <img src="/icons/svg/ideiacard-logo.svg" alt="Ideiacard Logo" />
                </div>

                <br /><br /><br />

                <div className="cardContainer loginFormInputContainer">
                  <h1>{t("employee_management")}</h1>

                  <div className="loginFormInput">
                    <input
                      type="text"
                      placeholder={t("login_id")}
                      value={loginIdInput}
                      onChange={(e) => setLoginIdInput(e.target.value)}
                    />
                  </div>

                  <div className="loginFormInput">
                    <input
                      type="password"
                      placeholder={t("password")}
                      value={passwordInput}
                      onChange={(e) => setPasswordInput(e.target.value)}
                    />
                  </div>

                  <div className="row">
                    <div className="col-6">
                      <div className="keepSignedInInput">
                        <input
                          type="checkbox"
                          id="keepSignedInCheckbox"
                          checked
                          disabled
                        />
                        <label htmlFor="keepSignedInCheckbox">
                          {t("keep_me_signed_in")}
                        </label>
                      </div>
                    </div>

                    <div className="col-6">
                      <div className="forgotPasswordContainer">
                        <a>{t("forgot_password")}</a>
                      </div>
                    </div>
                  </div>

                  <br /><br />

                  <p className="apiResponseText">{apiResponseText}</p>

                  <div className="row">
                    <div className="col-12">
                      <button className="loginButton" onClick={submitForm}>
                        {t("sign_in")}
                      </button>
                    </div>
                  </div>

                  <br /><br />
                </div>
              </div>
            </div>
          </div>

          <br /><br /><br />
        </div>
      </div>

      <LoaderScreen showLoaderScreenFlag={showLoaderScreenFlag} />
    </>
  );
}

export default Login;
